

export const Input = (props) => {
    return (
        <input
            className='!w-full p-5 rounded-lg border outline-none text-zinc-700 placeholder:text-zinc-700 text-base'
            {...props}
        />
    )
}